module.exports = __webpack_public_path__ + "static/home-1200w-e3b5d78afd84ca4367999904ae6d3709.jpg";